import Header from "./Components/Header";
import Hero from "./Components/Hero";
import Carousel from "./Components/Carousel/Carousel";
import { SliderData } from "./Components/Carousel/SliderData";
import Footer from "./Components/Footer";
import MoreFeatures from "./Components/MoreFeatures";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Carousel slides={SliderData} />
      <MoreFeatures />
      <Footer />
    </div>
  );
}

export default App;
